import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { catchError, lastValueFrom } from 'rxjs';
import { MessageResponse } from 'src/app/Interfaces/MessageResponse';
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/http-error-handler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttendingLeavingService {
  dataSource: any;
  private handleError: HandleError;
  public customDataSource: any;
  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler, public translatee: TranslateService,
    public NotifyService:NotifyService,
    public datepipe:DatePipe) {
    this.handleError = httpErrorHandler.createHandleError('ObjectService');
   }
  public submit(url:string) {
    this.customDataSource = new CustomStore({
      key: 'id',
      loadMode: 'raw',

      load: () => {
        return lastValueFrom(this.http.get(`${environment.apiRoot}/api/${url}/all`))
          .catch(() => { throw 'Data loading error' });
      },
      insert: (values) => {        
        if( values.timeAttending){values.timeAttending=this.datepipe.transform(values?.timeAttending,'h:mm:ss')}
        if( values.timeLeave){values.timeLeave=this.datepipe.transform(values?.timeLeave,'h:mm:ss')}
        return this.http.post<any>(`${environment.apiRoot}/api/${url}/Add`, values).pipe(
        ).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('add')

        });


      },
      update: (key, values) => {  
         if(values.time2 != undefined){
          values.time= values.time2        
          delete values.time2
         }        
        return this.http.put(`${environment.apiRoot}/api/${url}/Update`, values).pipe(

        ).toPromise().then((message: MessageResponse) => {

          this.NotifyService.notifyfun('edit')
        });
      },
      remove: (key) => {
        return this.http.delete(`${environment.apiRoot}/api/${url}/Delete?id=` + encodeURIComponent(key)).toPromise().then((message: MessageResponse) => {
          this.NotifyService.notifyfun('remove')

        })
      },
      errorHandler: function (error: any) {
        console.log(error.message);
      },


    });
  }

  search(name:string,params:{}){
    return this.http.get(`${environment.apiRoot}/api/${name}/all`, { params: params })
  }
  getAttendanceWithFilter(filters:any){
    return this.http.post(`${environment.apiRoot}/api/Attending_Leaving/all`,filters)
  }

  updateAttending(data :any){
    return this.http.put(`${environment.apiRoot}/api/Attending_Leaving/updateListOfAttending`,data)
  }
 deleteList(body: { ids: number[] }) {
  return this.http.delete(`${environment.apiRoot}/api/Attending_Leaving/DeleteListOfAttending`, { body });
}

}
